import { useCallback, useEffect, useState } from "react";

const CAMERA_CONSTRAINTS: MediaStreamConstraints[] = [
  {
    video: {
      width: { ideal: 640 },
      height: { ideal: 640 },
      facingMode: "user",
    },
    audio: false,
  },
  {
    video: { width: { ideal: 640 }, facingMode: "user" },
    audio: false,
  },
  {
    video: { width: { ideal: 480 }, facingMode: "user" },
    audio: false,
  },
];

export function useCamera() {
  const [stream, setStream] = useState<MediaStream | null>(null);

  const requestPermission = useCallback(async () => {
    for (const constraints of CAMERA_CONSTRAINTS) {
      try {
        const mediaStream =
          await navigator.mediaDevices.getUserMedia(constraints);
        setStream(mediaStream);
        return mediaStream;
      } catch (e) {
        const err = e as Error;
        console.warn(
          "getUserMedia failed:",
          constraints,
          err.name,
          err.message,
        );
      }
    }
    return null;
  }, []);

  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach((t) => t.stop());
      }
    };
  }, [stream]);

  return { requestPermission };
}
